<template>
    <div class="h-100 position-relative">
        <div class="not-available" v-if="isNotAvailable">Not Available</div>
        <Loader v-if="loading" :min-height="'100%'"></Loader>
        <ul class="list-group list-group-flush" v-if="list && list.length > 0">
            <li class="list-group-item" :key="index" v-for="(item, index) in list">
                <router-link
                    :title="item.title"
                    :to="{
                        name: 'quizzes.quiz.questions',
                        params: {
                            id: item._id.$oid
                        }
                    }"
                    class="d-flex align-items-center flex-1"
                    tag="a"
                >
                    <div
                        :style="`background-image: url(${item.image ? item.image : require('@/assets/no-image.jpg')})`"
                        class="bg-image"
                    ></div>
                    <div class="pl-3 flex-1">
                        <h3 class="mb-0 font-weight-bold" style="font-size: 1.2rem">{{ item.title }}</h3>
                    </div>
                </router-link>
            </li>
        </ul>
        <EmptyList min-height="100%" v-else />
    </div>
</template>

<script>
import EmptyList from '@/components/EmptyList'
import Loader from '@/components/Loader'

export default {
    name: 'popular-list',

    props: {
        list: {
            type: Array,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        isNotAvailable: {
            type: Boolean,
            default: false
        }
    },

    components: {
        EmptyList,
        Loader
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variable.scss';

.bg-image {
    width: 80px;
    height: 80px;
    border: 3px solid white;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 0.25rem;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}

.list-group-flush {
    counter-reset: ranking;

    .list-group-item {
        border-color: #eeeeee;
        display: flex;
        align-items: center;
        background-color: transparent;

        &::before {
            counter-increment: ranking;
            content: counter(ranking);
            width: 2.5rem;
            height: 2.5rem;
            margin-right: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: white;
            font-size: 1.3rem;
            font-weight: bold;
        }

        @for $i from 1 through 5 {
            $alpha: 1 - ($i / 10);

            &:nth-child(#{$i})::before {
                background-color: rgba($color-primary, $alpha);
            }
        }

        a {
            transition: 0.3s;
        }

        &:hover {
            a {
                transform: translateY(-3px);
            }
        }
    }
}

.not-available {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: red;
    border-radius: 0.25rem;
    color: white;
    padding: 0 0.5rem;
}
</style>
